import React, { useState } from "react";
import { Button } from "react-bootstrap";

export default function Setup({ getSiteDriveId }) {
   async function readM365Drives() {
      const relPath = "sites/Bender";
      console.log(relPath);

      const drives = await getSiteDriveId(relPath);
      const immobilienDrive = drives?.find((d) => d.name === "Immobilien" || d.webUrl.includes("Immobilien"));
      console.log("Gesuchte driveId:", immobilienDrive?.id);
   }

   return (
      <div className="m-4">
         <Button
            onClick={() => {
               readM365Drives();
            }}
         >
            Click
         </Button>
      </div>
   );
}
